import { ActionTypes } from 'redux/utils/List'

export default ActionTypes('REFERRAL_PRIORITY')